import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import assert from 'assert';
import ifvisible from 'ifvisible.js';
import { Store } from 'libx';
import memoizee from 'memoizee';
import { action, runInAction } from 'mobx';
import moment from 'moment';
import Queue from 'promise-queue';
import { concatMap } from 'rxjs/operators';
import { createNotifier } from '../misc/notifier';
import { makeMomentSorter } from '../utils/arrayUtil';
import { BackgroundDataLoader } from '../utils/bufferUtil';
import { collection } from '../utils/collection';
import { pageActivityStream } from '../utils/domUtil';
import Conversation from './Conversation';
import Message from './Message';
var sortByDate = makeMomentSorter('asc', function (x) {
  return x ? x.sentAt : moment();
});
var MessageStore = (_class = /*#__PURE__*/function (_Store) {
  function MessageStore() {
    var _this;
    _classCallCheck(this, MessageStore);
    _this = _callSuper(this, MessageStore, arguments);
    _this.getOnlineStatuses = _this.getOnlineStatuses.bind(_this);
    // This store is reused across multiple projects, so we assert
    // that the injected stores have the methods we need.
    assert(_this.rootStore, 'no rootStore passed to MessageStore');
    assert(_this.rootStore.userStore, 'rootStore needs a userStore');
    assert(_this.rootStore.authStore, 'rootStore needs an authStore');
    assert(_this.rootStore.authStore.onLogout, 'authStore needs an onLogout(fn) method');
    assert(_this.rootStore.authStore.token$, 'authStore needs a token$ observable');
    _this.markAsReadQueue = [];
    _this.onIncomingMessage = createNotifier();

    // TODO(@Juan) pass in conversation to Message instance
    // instead of making message look up conversations collection in messageStore
    // via root store
    _this.messages = _this.collection({
      model: Message
    });
    _this.conversations = collection({
      create: function create(attrs) {
        return new Conversation(_this.rootStore.memberStore.setAndFetch.bind(_this.rootStore.memberStore));
      }
    });
    _this.fetchQueue = new Queue(1);
    var messagingAPI = _this.rootStore.messagingAPI;
    _this.api = messagingAPI.conversations;
    _this.rootStore.authStore.onLogout(action(function () {
      _this.messages.clear();
      _this.conversations.clear();
      _this.videoParticipants.clear();
    }));
    _this.fetchConversation = memoizee(_this.fetchConversation.bind(_this), {
      promise: true,
      length: 1
    });
    ifvisible.on('focus', function () {
      return _this.drainMarkAsReadQueue();
    });
    ifvisible.on('wakeup', function () {
      return _this.drainMarkAsReadQueue();
    });
    _this.bufferUtil = new BackgroundDataLoader(pageActivityStream(), _this.rootStore.authStore.stale$);
    _this.bufferUtil.start(function (x) {
      return _this.getOnlineStatuses(x);
    });
    messagingAPI.events$.pipe(concatMap(function (e) {
      return _this.handleEvent(e);
    })).subscribe();
    return _this;
  }
  _inherits(MessageStore, _Store);
  return _createClass(MessageStore, [{
    key: "drainMarkAsReadQueue",
    value: function drainMarkAsReadQueue() {
      var _this2 = this;
      if (this.markAsReadQueue.length === 0) {
        return;
      }
      this.markAsReadQueue.forEach(function (message) {
        _this2.markAsRead(message);
      });
      this.markAsReadQueue = [];
    }
  }, {
    key: "handleEvent",
    value: function () {
      var _handleEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var message, job, _message, messageStatus, _message2, _messageStatus;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (data.type) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.t0 = data.type;
              _context.next = _context.t0 === 'MESSAGE_CREATED' ? 5 : _context.t0 === 'MESSAGE_READ' ? 16 : _context.t0 === 'MESSAGE_DELIVERED' ? 21 : _context.t0 === 'MESSAGE_DELETED' ? 26 : _context.t0 === 'PARTICIPANT_STATUS_CHANGED' ? 30 : 32;
              break;
            case 5:
              _context.next = 7;
              return this.fetchConversation(data.payload.conversation_id);
            case 7:
              _context.next = 9;
              return this._addMessages([data.payload]);
            case 9:
              message = this.messages.get(data.payload.id);
              this.onIncomingMessage.notify(message);
              if (!(data.payload.content.external_type === 'worklayer.jobs.Progression')) {
                _context.next = 15;
                break;
              }
              job = this.rootStore.jobStore.forConversation(message.conversationId);
              _context.next = 15;
              return this.rootStore.jobProgressionStore.fetchProgression(job.id);
            case 15:
              return _context.abrupt("break", 32);
            case 16:
              _context.next = 18;
              return this.fetchConversation(data.payload.conversation_id);
            case 18:
              _message = this.messages.find(function (x) {
                return x.id === data.payload.id;
              });
              if (_message) {
                messageStatus = _message.allRecipientStatuses.find(function (x) {
                  return x.recipientUserId === data.payload.user_id;
                });
                if (messageStatus) {
                  runInAction(function () {
                    messageStatus.status = 'READ';
                  });
                }
              }
              return _context.abrupt("break", 32);
            case 21:
              _context.next = 23;
              return this.fetchConversation(data.payload.conversation_id);
            case 23:
              _message2 = this.messages.find(function (x) {
                return x.id === data.payload.id;
              });
              if (_message2) {
                _messageStatus = _message2.allRecipientStatuses.find(function (x) {
                  return x.recipientUserId === data.payload.user_id;
                });
                if (_messageStatus) {
                  runInAction(function () {
                    _messageStatus.status = 'DELIVERED';
                  });
                }
              }
              return _context.abrupt("break", 32);
            case 26:
              _context.next = 28;
              return this.fetchConversation(data.payload.conversation_id);
            case 28:
              this.messages.remove(data.payload.id);
              return _context.abrupt("break", 32);
            case 30:
              // the events can come in out of order...
              // lets just call the endpoint to get the correct one
              this.enqueueOnlineStatusSync(data.payload.user_public_id);
              return _context.abrupt("break", 32);
            case 32:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleEvent(_x) {
        return _handleEvent.apply(this, arguments);
      }
      return handleEvent;
    }()
  }, {
    key: "enqueueOnlineStatusSync",
    value: function enqueueOnlineStatusSync(id) {
      this.bufferUtil.load(id);
    }
  }, {
    key: "getOnlineStatuses",
    value: function () {
      var _getOnlineStatuses = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ids) {
        var _this3 = this;
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.api.isOnline(ids);
            case 2:
              result = _context3.sent;
              _context3.next = 5;
              return Promise.all(result.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(s) {
                  var user;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!s) {
                          _context2.next = 7;
                          break;
                        }
                        user = _this3.rootStore.userStore.users.find(function (u) {
                          return u.public_id === s.user_public_id;
                        });
                        if (user) {
                          _context2.next = 6;
                          break;
                        }
                        _context2.next = 5;
                        return _this3.rootStore.userStore.fetchByPublicId(s.user_public_id);
                      case 5:
                        user = _context2.sent;
                      case 6:
                        if (user) {
                          user.set({
                            online:
                            // current user is always online
                            _this3.rootStore.sessionStore.user.public_id === s.user_public_id || s.online,
                            lastSynced: new Date()
                          });
                        }
                      case 7:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 5:
              return _context3.abrupt("return", result);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getOnlineStatuses(_x2) {
        return _getOnlineStatuses.apply(this, arguments);
      }
      return getOnlineStatuses;
    }()
  }, {
    key: "messagesIn",
    value: function messagesIn(conversationId) {
      var messages = this.messages.filter(function (x) {
        return x.conversationId === conversationId;
      });
      return messages.sort(sortByDate);
    }

    /**
     * Gets the unread message count in the conversation.
     * @param conversationId
     */
  }, {
    key: "unreadIn",
    value: function unreadIn(conversationId) {
      var unread = this.messages.filter(function (x) {
        return x.conversationId === conversationId && x.isRead === false;
      });
      return unread.length;
    }
  }, {
    key: "loadMore",
    value: function () {
      var _loadMore = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(conversationId, teamId) {
        var convo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              convo = this.conversations.get(conversationId);
              convo.loadingMore = true;
              _context4.next = 4;
              return this.fetchMessagesForConversation(conversationId, teamId);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function loadMore(_x4, _x5) {
        return _loadMore.apply(this, arguments);
      }
      return loadMore;
    }()
  }, {
    key: "_addMessages",
    value: function () {
      var _addMessages2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
        var _this4 = this;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // Adds messages to the store but makes sure
              // all related entities are present first.
              data.forEach(function (message) {
                var job = _this4.rootStore.jobStore.forConversation(message.conversationId);
                if (job) {
                  _this4.rootStore.memberStore.fetchByPublicId({
                    workspace_id: job.workspaceId,
                    user_public_id: message.user_public_id
                  });
                }
              });

              // Make sure to fetch prompts since we don't have good view model
              // infrastructure around messages to do this in a nicer way
              _context5.next = 3;
              return Promise.all(data.map(function (messageDto) {
                return _this4._maybeFetchPrompt(messageDto);
              }));
            case 3:
              runInAction(function () {
                _this4.messages.set(data);
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function _addMessages(_x6) {
        return _addMessages2.apply(this, arguments);
      }
      return _addMessages;
    }()
  }, {
    key: "primeConversation",
    value: function primeConversation(props) {
      if (!props || !props.id) {
        return undefined;
      }
      return this.conversations.set(props);
    }
  }, {
    key: "fetchConversation",
    value: function () {
      var _fetchConversation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(conversationId) {
        var _this5 = this;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.api.getConversationById(conversationId).then(function (data) {
                return _this5.conversations.set(data);
              }));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fetchConversation(_x7) {
        return _fetchConversation.apply(this, arguments);
      }
      return fetchConversation;
    }()
  }, {
    key: "fetchMessagesForConversation",
    value: function () {
      var _fetchMessagesForConversation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(conversationId, teamId) {
        var _this6 = this;
        var convo;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.fetchConversation(conversationId);
            case 2:
              convo = this.conversations.get(conversationId);
              if (!(convo && !convo.cursor && convo.notFirst)) {
                _context8.next = 5;
                break;
              }
              return _context8.abrupt("return", this.messagesIn(conversationId));
            case 5:
              return _context8.abrupt("return", new Promise(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resolve, reject) {
                  var messages, newError;
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.prev = 0;
                        _context7.next = 3;
                        return _this6.api.getMessages(conversationId, _objectSpread({
                          limit: 30,
                          after: (convo || {}).cursor,
                          include_status: true
                        }, teamId && {
                          team_id: teamId
                        }));
                      case 3:
                        messages = _context7.sent;
                        _context7.next = 6;
                        return _this6._addMessages(messages.data);
                      case 6:
                        runInAction(function () {
                          return _this6.conversations.set({
                            cursor: messages.cursor,
                            id: conversationId,
                            notFirst: true,
                            accessDenied: false,
                            loadingMore: false,
                            hasMoreMessages: messages.cursor !== null
                          });
                        });
                        resolve();
                        _context7.next = 16;
                        break;
                      case 10:
                        _context7.prev = 10;
                        _context7.t0 = _context7["catch"](0);
                        newError = new Error('You are not a participant in this conversation.');
                        newError.errorType = 'NOT_IN_CONVO';
                        _this6.conversations.set({
                          id: conversationId,
                          accessDenied: true
                        });
                        return _context7.abrupt("return", reject(newError));
                      case 16:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7, null, [[0, 10]]);
                }));
                return function (_x10, _x11) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function fetchMessagesForConversation(_x8, _x9) {
        return _fetchMessagesForConversation.apply(this, arguments);
      }
      return fetchMessagesForConversation;
    }()
  }, {
    key: "queueFetchMessagesForConversation",
    value: function () {
      var _queueFetchMessagesForConversation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(conversationId, teamId) {
        var _this7 = this;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.fetchQueue.add(function () {
                return _this7.fetchMessagesForConversation(conversationId, teamId);
              }));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function queueFetchMessagesForConversation(_x12, _x13) {
        return _queueFetchMessagesForConversation.apply(this, arguments);
      }
      return queueFetchMessagesForConversation;
    }()
  }, {
    key: "sendNote",
    value: function () {
      var _sendNote = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref3) {
        var _this8 = this;
        var conversationId, text, teamId, conversation, message;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              conversationId = _ref3.conversationId, text = _ref3.text, teamId = _ref3.teamId;
              conversation = this.conversations.get(conversationId);
              if (!teamId) {
                _context10.next = 8;
                break;
              }
              _context10.next = 5;
              return this.api.createTeamNote(text, conversationId, teamId);
            case 5:
              message = _context10.sent;
              _context10.next = 11;
              break;
            case 8:
              _context10.next = 10;
              return this.api.createNote(text, conversationId);
            case 10:
              message = _context10.sent;
            case 11:
              runInAction(function () {
                _this8.messages.set(message, {
                  createdHere: true
                });
              });
              if (conversation && !conversation.muted) {
                this.rootStore.soundStore.playSendMessage();
              }
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function sendNote(_x14) {
        return _sendNote.apply(this, arguments);
      }
      return sendNote;
    }()
  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref4) {
        var _this9 = this;
        var conversationId, text, conversation, message;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              conversationId = _ref4.conversationId, text = _ref4.text;
              conversation = this.conversations.get(conversationId);
              _context11.next = 4;
              return this.api.createMessage(text, conversationId);
            case 4:
              message = _context11.sent;
              runInAction(function () {
                _this9.messages.set(message, {
                  createdHere: true
                });
              });
              if (conversation && !conversation.muted) {
                this.rootStore.soundStore.playSendMessage();
              }
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function sendMessage(_x15) {
        return _sendMessage.apply(this, arguments);
      }
      return sendMessage;
    }()
  }, {
    key: "deleteMessage",
    value: function () {
      var _deleteMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(id) {
        var _this10 = this;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.api.deleteMessage(id);
            case 2:
              runInAction(function () {
                _this10.messages.remove(id);
              });
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function deleteMessage(_x16) {
        return _deleteMessage.apply(this, arguments);
      }
      return deleteMessage;
    }()
  }, {
    key: "markAsRead",
    value: function () {
      var _markAsRead = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(message) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!this.rootStore.authStore.user.impersonator) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              if (!(message.type === 'NOTE' || message.type === 'TEAM_NOTE' || message.type === 'ADMIN_NOTE')) {
                _context13.next = 4;
                break;
              }
              return _context13.abrupt("return");
            case 4:
              if (!(ifvisible.now('hidden') || ifvisible.now('idle') || !this.rootStore.sessionStore.workspace)) {
                _context13.next = 7;
                break;
              }
              this.markAsReadQueue.push(message);
              return _context13.abrupt("return");
            case 7:
              _context13.next = 9;
              return this.api.markRead([message], this.rootStore.sessionStore.workspace.id);
            case 9:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function markAsRead(_x17) {
        return _markAsRead.apply(this, arguments);
      }
      return markAsRead;
    }()
  }, {
    key: "getMyParticipant",
    value: function () {
      var _getMyParticipant = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(conversationId) {
        var _this11 = this;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this.api.getParticipant({
                conversation_id: conversationId,
                user_id: this.rootStore.sessionStore.member.userPublicId
              }).then(function (participant) {
                var convo = _this11.conversations.get(conversationId);
                // we should only update the convo if its already there
                // otherwise something is baaaad
                if (convo) {
                  convo.set({
                    muted: participant.muted
                  });
                }
              }));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function getMyParticipant(_x18) {
        return _getMyParticipant.apply(this, arguments);
      }
      return getMyParticipant;
    }()
  }, {
    key: "toggleMute",
    value: function () {
      var _toggleMute = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(conversationId) {
        var conversation;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              conversation = this.conversations.get(conversationId);
              if (!conversation) {
                _context15.next = 3;
                break;
              }
              return _context15.abrupt("return", conversation.muted ? this.unMuteParticipant(conversation.id) : this.muteParticipant(conversation.id));
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function toggleMute(_x19) {
        return _toggleMute.apply(this, arguments);
      }
      return toggleMute;
    }()
  }, {
    key: "muteParticipant",
    value: function () {
      var _muteParticipant = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(conversationId) {
        var conversation, participant;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              conversation = this.conversations.get(conversationId);
              if (!conversation) {
                _context16.next = 7;
                break;
              }
              _context16.next = 4;
              return this.api.updateParticipant({
                user_id: this.rootStore.sessionStore.member.userPublicId,
                muted: true,
                conversation_id: conversationId
              });
            case 4:
              participant = _context16.sent;
              if (!participant) {
                _context16.next = 7;
                break;
              }
              return _context16.abrupt("return", this.conversations.set({
                id: conversation.id,
                muted: participant.muted
              }));
            case 7:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function muteParticipant(_x20) {
        return _muteParticipant.apply(this, arguments);
      }
      return muteParticipant;
    }()
  }, {
    key: "unMuteParticipant",
    value: function () {
      var _unMuteParticipant = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(conversationId) {
        var conversation, participant;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              conversation = this.conversations.get(conversationId);
              if (conversation) {
                _context17.next = 3;
                break;
              }
              return _context17.abrupt("return");
            case 3:
              _context17.next = 5;
              return this.api.updateParticipant({
                user_id: this.rootStore.sessionStore.member.userPublicId,
                muted: false,
                conversation_id: conversationId
              });
            case 5:
              participant = _context17.sent;
              return _context17.abrupt("return", this.conversations.set({
                id: conversation.id,
                muted: participant.muted
              }));
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function unMuteParticipant(_x21) {
        return _unMuteParticipant.apply(this, arguments);
      }
      return unMuteParticipant;
    }()
  }, {
    key: "_maybeFetchPrompt",
    value: function () {
      var _maybeFetchPrompt2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(messageDto) {
        var _messageDto$content;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (!(((_messageDto$content = messageDto.content) === null || _messageDto$content === void 0 ? void 0 : _messageDto$content.type) !== 'EXTERNAL_REFERENCE')) {
                _context18.next = 2;
                break;
              }
              return _context18.abrupt("return");
            case 2:
              if (!(messageDto.content.external_type !== 'worklayer.jobs.Prompt')) {
                _context18.next = 4;
                break;
              }
              return _context18.abrupt("return");
            case 4:
              _context18.prev = 4;
              _context18.next = 7;
              return this.rootStore.promptStore.getPrompt(messageDto.content.external_id);
            case 7:
              _context18.next = 12;
              break;
            case 9:
              _context18.prev = 9;
              _context18.t0 = _context18["catch"](4);
              console.error("Loading prompt ".concat(messageDto.content.external_id, " failed"), _context18.t0);
            case 12:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this, [[4, 9]]);
      }));
      function _maybeFetchPrompt(_x22) {
        return _maybeFetchPrompt2.apply(this, arguments);
      }
      return _maybeFetchPrompt;
    }()
  }]);
}(Store), _applyDecoratedDescriptor(_class.prototype, "loadMore", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadMore"), _class.prototype), _class);
export { MessageStore as default };
//# sourceMappingURL=MessageStore.js.map
